$(document).on('turbolinks:load', function() {
  $('#employee-schedules-table').dataTable({
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": $('#employee-schedules-table').data('source')
    },
    "pagingType": "full_numbers",
    "columns": [
      {"data": "employee"},
      {"data": "scheduled_day"}, 
      {"data": "start_time"},
      {"data": "end_time"}, 
      {"data": "ops"},
    ], 
    columnDefs: [{ "orderable": false, "targets": 4 }, { "width": "5%", "targets": 4 },{ "className": 'dt-center', "targets": 4 }]
  });
});